/** @format */

const scorecards = document.querySelector('#mcw-anesth-scorecards');
const myScorecard = document.querySelector('#mcw-anesth-my-scorecard');
const residentClinicalDashboard = document.querySelector(
	'#mcw-anesth-resident-clinical-dashboard'
);

if (scorecards) {
	createScorecards();
}

if (myScorecard) {
	createMyScorecard();
}

if (residentClinicalDashboard) {
	createResidentClinicalDashboard();
}

async function createScorecards() {
	const FacultyScorecards = await import('./svelte-components/FacultyScorecards.svelte').then(
		r => r.default
	);

	new FacultyScorecards({
		target: scorecards
	});
}

async function createMyScorecard() {
	const MyScorecard = await import('./svelte-components/MyScorecard.svelte').then(
		r => r.default
	);

	new MyScorecard({
		target: myScorecard
	});
}

async function createResidentClinicalDashboard() {
	const ResidentClinicalDashboard = await import('./svelte-components/ResidentDashboard.svelte').then(
		r => r.default
	);

	new ResidentClinicalDashboard({
		target: residentClinicalDashboard
	});
}
